/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Question } from './Question';
import { QuestionFromJSON, QuestionFromJSONTyped, QuestionToJSON } from './Question';

/**
 *
 * @export
 * @interface PaginatedQuestionList
 */
export interface PaginatedQuestionList {
  /**
   *
   * @type {number}
   * @memberof PaginatedQuestionList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedQuestionList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedQuestionList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<Question>}
   * @memberof PaginatedQuestionList
   */
  results: Array<Question>;
}

/**
 * Check if a given object implements the PaginatedQuestionList interface.
 */
export function instanceOfPaginatedQuestionList(value: object): value is PaginatedQuestionList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedQuestionListFromJSON(json: any): PaginatedQuestionList {
  return PaginatedQuestionListFromJSONTyped(json, false);
}

export function PaginatedQuestionListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedQuestionList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(QuestionFromJSON),
  };
}

export function PaginatedQuestionListToJSON(value?: PaginatedQuestionList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(QuestionToJSON),
  };
}
